import clsx from 'clsx';
import { useTheme } from '@/contexts/ThemeContext';

interface LogoProps {
  /**
   * `auto` (default): segue o tema (`dark` → logo escura; `light` → logo clara).
   * `dark-bg`: força a logo desenhada para fundos escuros (use na sidebar, que é sempre escura).
   * `light-bg`: força a logo desenhada para fundos claros.
   */
  variant?: 'auto' | 'dark-bg' | 'light-bg';
  className?: string;
  alt?: string;
}

export function Logo({ variant = 'auto', className, alt = 'Starbridge' }: LogoProps) {
  const { theme } = useTheme();
  const onDarkBg = variant === 'dark-bg' || (variant === 'auto' && theme === 'dark');
  const src = onDarkBg ? '/logo-dark.png' : '/logo-light.png';
  return (
    <img
      src={src}
      alt={alt}
      className={clsx('select-none', className)}
      draggable={false}
    />
  );
}
